import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';

class PsDividerComponent {
    constructor() {
        this._inset = false;
        this._fat = false;
    }
    /** Whether the divider is an inset divider. */
    get inset() {
        return this._inset;
    }
    set inset(value) {
        this._inset = coerceBooleanProperty(value);
    }
    /** Whether the divider is with greater border width (2px) */
    get fat() {
        return this._fat;
    }
    set fat(value) {
        this._fat = coerceBooleanProperty(value);
    }
    get psDivider() {
        return true;
    }
    get psNormalDivider() {
        return !this.fat;
    }
    get psDividerRole() {
        return 'separator';
    }
    get dividerOrientation() {
        return 'horizontal';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PsDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PsDividerComponent, selector: "ps-divider", inputs: { inset: "inset", fat: "fat" }, host: { properties: { "class.ps-divider-inset": "this.inset", "class.ps-fat-divider": "this.fat", "class.ps-divider": "this.psDivider", "class.ps-normal-divider": "this.psNormalDivider", "attr.role": "this.psDividerRole", "attr.aria-orientation": "this.dividerOrientation" } }, ngImport: i0, template: '', isInline: true, styles: [".ps-divider{display:block;margin:0}.ps-divider.ps-fat-divider{border-top-width:.125rem;border-top-style:solid}.ps-divider.ps-normal-divider{border-top-width:.0625rem;border-top-style:solid}.ps-divider.ps-divider-inset{margin-left:5rem}[dir=rtl] .ps-divider.ps-divider-inset{margin-left:auto;margin-right:5rem}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PsDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ps-divider', template: '', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".ps-divider{display:block;margin:0}.ps-divider.ps-fat-divider{border-top-width:.125rem;border-top-style:solid}.ps-divider.ps-normal-divider{border-top-width:.0625rem;border-top-style:solid}.ps-divider.ps-divider-inset{margin-left:5rem}[dir=rtl] .ps-divider.ps-divider-inset{margin-left:auto;margin-right:5rem}\n"] }]
        }], propDecorators: { inset: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.ps-divider-inset']
            }], fat: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.ps-fat-divider']
            }], psDivider: [{
                type: HostBinding,
                args: ['class.ps-divider']
            }], psNormalDivider: [{
                type: HostBinding,
                args: ['class.ps-normal-divider']
            }], psDividerRole: [{
                type: HostBinding,
                args: ['attr.role']
            }], dividerOrientation: [{
                type: HostBinding,
                args: ['attr.aria-orientation']
            }] } });

class PsDividerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PsDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PsDividerModule, declarations: [PsDividerComponent], imports: [CommonModule], exports: [PsDividerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PsDividerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PsDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [PsDividerComponent],
                    declarations: [PsDividerComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PsDividerComponent, PsDividerModule };
